import { initialHoldingsState, IHoldingsState } from 'src/app/store/state/holdings.state';
import * as SystemActions from 'src/app/store/system/actions/system.actions';
import * as HoldingsActions from '../actions/holdings.actions';

export function HoldingsReducer(state = initialHoldingsState, action: HoldingsActions.HoldingsActions | SystemActions.SystemActions): IHoldingsState {
    switch (action.type) {
        case HoldingsActions.SET_HOLDINGS_VALUATION_DATA:
            return {
                ...state,
                holdingsValuationData: action.payload.holdingsValuationData,
                selectedDate: action.payload.date,
                selectedEntities: action.payload.clientEntities,
                selectedPortfolios: action.payload.portfolios,
                loading: false,
                isValuationsDataLoaded: true,
                selectedAssetPerformanceCollection: {}
            };
        case HoldingsActions.SET_HOLDINGS_EXPOSURES_DATA:
            return {
                ...state,
                holdingsExposuresData: action.payload.holdingsExposuresData,
                selectedDate: action.payload.date,
                selectedEntities: action.payload.clientEntities,
                selectedPortfolios: action.payload.portfolios,
                loading: false
            };
        case HoldingsActions.GET_HOLDINGS_EXPOSURES_DATA:
        case HoldingsActions.GET_HOLDINGS_ALLOCATIONS_DATA:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case HoldingsActions.GET_HOLDINGS_VALUATION_DATA:
            return {
                ...state,
                loading: true,
                error: false,
                isValuationsDataLoaded: false
            };
        case HoldingsActions.HOLDINGS_DATA_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
                errorMessage: action.payload
            };
        case HoldingsActions.SELECT_ASSET:
            return {
                ...state,
                selectedAssetId: action.payload.assetId
            };
        case HoldingsActions.SET_ASSET_PERFORMANCE:
            return {
                ...state,
                selectedAssetPerformanceCollection: {
                    ...state.selectedAssetPerformanceCollection,
                    [action.payload.assetId]: action.payload
                }
            };
        case HoldingsActions.SET_AVAILABLE_BALANCE:
            return {
                ...state,
                availableBalance: action.payload
            };
        case SystemActions.CLEAR_SYSTEM:
            return initialHoldingsState;
        default:
            return state;
    }
}
